import {GET_TokenUserRegister} from '../constants/ActionTypes'

const INIT_STATE = {
    
    tokenMessage: null,
  
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case GET_TokenUserRegister:
            return {
                tokenMessage: action.body,
             
                
            }
           
           
            
        default:
            return state;
    }
}